// extracted by mini-css-extract-plugin
module.exports = {"popover":"freeSearchTooltip_popover__A839I","popoverBody":"freeSearchTooltip_popoverBody__pUDZz"};